import { Box, CircularProgress, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { logoutAndRedirect } from '@sophocles/features/auth/authActions';
// eslint-disable-next-line no-restricted-imports -- pre-existing apiClient usage; migrate to api/<domain>.js when touched
import apiClient from '@sophocles/http-common';
import tokenService from '@sophocles/services/token';
import store from '@sophocles/store/redux-store';

export default function AuthCallback() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [error, setError] = useState(null); // State to hold any error messages

  useEffect(() => {
    const handleAuthCallback = async () => {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const code = urlSearchParams.get('code');
      const state = urlSearchParams.get('state');
      window.history.replaceState({}, document.title, '/callback');

      const poolId = tokenService.pool;

      if (!code || !poolId) {
        console.warn('No code or pool id, logging out.');
        tokenService.logout();
        window.location.href = '/login';
      } else {
        tokenService.state = null;

        try {
          const { data } = await apiClient.get(`/auth/cognito/${poolId}/callback?code=${code}&state=${state}`);
          if (!data.id_token) {
            console.log('No ID token, logging out.');
            tokenService.logout();
            window.location.href = '/login';
          }

          tokenService.parseTokens(data);
          tokenService.authMethod = 'federated';
          window.location.href = '/';
        } catch (error) {
          console.error('Failed to get tokens:', error);

          // Check if the error response contains a message
          let errorMessage = 'An unknown error occurred.';
          if (error.response && error.response.data && error.response.data.detail) {
            errorMessage = error.response.data.detail;
          } else if (error.message) {
            errorMessage = error.message;
          }

          setError(errorMessage); // Set the error message to state
          tokenService.logout();
        }
      }
    };

    handleAuthCallback();
  }, []);

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress />
      <Typography>{t('auth.signingIn', 'Signing you in...')}</Typography>
      {error && (
        <Typography color="error" style={{ marginTop: '1rem', textAlign: 'center' }}>
          {error}
        </Typography>
      )}
    </Box>
  );
}
